<template>
  <div class="flex flex-row gap-16">
    <div class="max-w-110">
      <p v-if="chargerIncluded" class="heading-xxs">Laddare medföljer</p>
      <p v-else class="heading-xxs">Laddare medföljer ej</p>
      <NuxtImg
        v-if="chargerIncluded"
        src="/images/product_related/charger_included.svg"
        alt=""
        class="w-110"
        loading="lazy"
        width="110"
        provider="cloudfront"
      />
      <NuxtImg
        v-else
        src="/images/product_related/charger_not_included.svg"
        alt=""
        class="w-110 h-[15rem]"
        loading="lazy"
        width="110"
        provider="cloudfront"
      />
    </div>
    <div class="max-w-110">
      <p class="heading-xxs">Produkten använder:</p>
      <div class="relative">
        <div class="absolute top-60 left-15 w-80 h-80 pt-4 text-center">
          <p class="heading-xxs text-text-on-highlight font-xtrabold">
            {{ wiredChargerMinWatts }} - {{ wiredChargerMaxWatts }}
          </p>
          <p class="heading-xxs text-text-on-highlight font-xtrabold">W</p>
          <p
            v-if="usbPdSupported"
            class="heading-xxs text-text-on-highlight font-xtrabold"
          >
            USB PD
          </p>
        </div>
        <NuxtImg
          src="/images/product_related/charger_included.svg"
          alt=""
          class="w-110 h-[15rem]"
          loading="lazy"
          width="110"
          provider="cloudfront"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  chargerIncluded: boolean;
  wiredChargerMinWatts: string;
  wiredChargerMaxWatts: string;
  usbPdSupported?: boolean;
}
defineProps<Props>();
</script>

<style lang="scss" scoped></style>
